import HeroFour from "../components/Hero/HeroFour";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import CaseStudyOne from "../components/CaseStudies/CaseStudyOne";
import PortfolioClient from "../components/ClientLogoSlider/PortfolioClient";
import AboutCompany from "../components/About/AboutOne";
import FunFactCounterTwo from "../components/FunFact/FunFactCounterTwo";
import ServiceThree from "../components/Services/ServiceThree";
import AboutBenefit from "../components/About/AboutBenefit";
import CardCoreFeatures from "../components/Features/FeatureSix";
import FaqFour from "../components/FaqCom/FaqFour";
import LatestBlog from "../components/LatestBlog/LatestBlogOne";
import { useContentAvailability } from "../utils/contentAvailability";


const faqs = [
  {
    question: "How is Impera different from other tech providers?",
    answer:
      "We focus on fast, flexible, and cost-effective solutions using low-code and automation. Our approach is hands-on, people-focused, and results-driven.",
  },
  {
    question: "Do I need technical knowledge to work with you?",
    answer:
      "Not at all. We make the process easy to understand and guide you every step of the way—no tech skills needed.",
  },
  {
    question: "Can Impera help us scale as we grow?",
    answer:
      "Yes. Our solutions are designed to grow with your business, whether you’re starting small or expanding fast.",
  },
  {
    question: "What kind of support will I get during the project?",
    answer:
      "You get a dedicated team, regular check-ins, and full transparency throughout the process—from planning to launch and beyond.",
  },
  // Add more FAQ items here if needed
];

const funFacts = [
  {
    value: 40,
    suffix: "+",
    label: "Projects Delivered",
    delay: 0,
  },
  {
    value: 10,
    suffix: "+",
    label: "Years of proven experience",
    delay: 100,
  },
  {
    value: 5,
    suffix: "+",
    label: "Countries Served",
    delay: 200,
  },
  {
    value: 1000,
    suffix: "+",
    label: "Business Processes Automated",
    delay: 300,
  },
];

const services = [
  {
    icon: "/assets/images/Vector.webp",
    title: "Automation & Logistics",
    description:
      "Seamless last-mile delivery enabled by automated dispatch, microservices, synchronized databases, and data lakes for centralized insights.",
    delay: "0",
    slug: "automation-logistics",
  },
  {
    icon: "/assets/images/Vector-1.webp",
    title: "Cloud Migration",
    description:
      "Moving to the cloud doesn't have to be complicated. We design and execute robust migration strategies, covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment.",
    delay: "100",
    slug: "cloud-migration",
  },
  {
    icon: "/assets/images/Vector-2.webp",
    title: "Optimized Customer Onboarding",
    description:
      "This service re-engineers and automates the customer onboarding journey with customized back-end solutions for faster, more accurate, and seamless experiences.",
    delay: "200",
    slug: "customer-onboarding",
  }
];


export default function HomeFour() {
  const { hasBlogs, hasCaseStudies } = useContentAvailability();

  return (
    <InnerPageLayout>
      <div className="home-four relative w-full overflow-x-hidden">
        <HeroFour />
        <PortfolioClient />
        <AboutCompany />
        <FunFactCounterTwo funFacts={funFacts} />
        <ServiceThree services={services} />
        <AboutBenefit />
        <CardCoreFeatures />
        {hasCaseStudies && <CaseStudyOne />}
        <FaqFour faqs={faqs} />
        {hasBlogs && <LatestBlog />}
      </div>
    </InnerPageLayout>
  );
}
